import React, { Component, Fragment } from "react";
import {
  Grid,
  withStyles,
  Card,
  CardContent,
  Typography,
  CardHeader,
  IconButton,
  useMediaQuery,
  Backdrop,
  Link,
  Divider,
  Table,
  TableHead,
  FormControl,
  Select,
  MenuItem,
  InputBase,
  InputAdornment,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
  Switch,
  Tooltip,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { useStyles } from "./common/useStyles";
import "./common/Common.css";
import classNames from "classnames";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import ViewImage from "./ViewImage";
import api from "./common/APIValues";
import axios from "axios";
import EDWhatLogoIcon from "./images/EdWhat-01-01.png";
import RemoveIcon from "@material-ui/icons/Delete";
import ReactHtmlParser from "react-html-parser";
import CommonFunc from "./common/CommonFunc";
import routeService from "../services/Routing";
import constant from "../components/common/Constants";
import { searchByInputs, get, update } from "../services/ApiService";
import { Edit as EditIcon } from "@material-ui/icons"; // Import EditIcon
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ArrowForwardIosSharpIcon from "@material-ui/icons/ArrowForwardIosSharp";
import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@material-ui/core";
import UploadFile from "../pages/modal/UploadFile";

const withMediaQuery =
  (...args) =>
  (Component) =>
  (props) => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
  };

const MuiAccordion = styled((props) => (
  <Accordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const MuiAccordionSummary = styled((props) => (
  <AccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon style={{ fontSize: "1rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .AccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(45deg)",
  },
  "& .AccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const MuiAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

class AssignmentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      community: {},
      userAssignment: {},
      uploadedAssignments: [],
      loader: false,
      viewImage: false,
      editDialogOpen: false,
      editedTitle: "",
      editedDescription: "",
      showUpload: false,
      assignmentId: null,
      groupId: 0,
      userAssignmentStatus: [],
      checked: true,
    };
  }

  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.validateUserPermission();
  }

  validateUserPermission = () => {
    const pathName = this.props.location.pathname;
    if (pathName.indexOf("/assignment/") > -1) {
      const pathParams = pathName.split("/");
      let assignmentId = pathParams[4];
      this.setState({assignmentId: assignmentId});
      const inputs = assignmentId + "/" + api.env;
      searchByInputs("UserAssignment/GetCommunityByAssignment", inputs).then(
        (response) => {
          if (Number(response) > 0) {
            const groupId = Number(response);
            this.setState({groupId: groupId});
            this.loadCommunity(groupId).then(() => {
              const groupStatus = this.state.community.UserGroupStatus;
              this.loadUserAssignment(assignmentId);
              this.loadUploadedAssignments(this.props.userEmail, assignmentId, groupId);
              this.loadAssignmentStatus(this.props.userEmail, assignmentId, groupId, groupStatus);
              this.loadAllowAssignmentSubmission(assignmentId);
            })
          }
        }
      );
    }
  };

  loadAssignmentStatus = (userId, assignmentId, groupId, groupStatus) => {
    const originName = window.location.origin.replace('www.', '');
    this.setState({ loader: true });
    const email = "";
    let url = api.partialURL + "UserAssignment/GetAssignmentStatus?ASSIGNMENT_ID=" + assignmentId +
      "&GROUP_ID=" + groupId +
      "&USER_ID=" + userId +
      "&GROUP_STATUS=" + groupStatus +
      '&originName=' + originName +
      "&ENV=" + api.env;

    fetch(url)
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          userAssignmentStatus: result,
          loader: false,
        });
      })
      .catch((err) => console.log(err));
  };

  loadCommunity = (groupId) => {
    const originName = window.location.origin.replace("www.", "");
    this.setState({ loader: true });
    let url =
      api.partialURL +
      "Community/GetCommunity?GroupId=" +
      groupId +
      "&UserId=" +
      this.props.userEmail +
      "&ENV=" +
      api.env +
      "&originName=" +
      originName;
    return this.fetchCommunity(url, groupId);
  };

  fetchCommunity = (url, groupId) => {
    return fetch(url)
      .then((res) => res.json())
      .then((result) => {
        const userGroupStatus = result.UserGroupStatus;
        if (
          userGroupStatus === "" ||
          userGroupStatus === null ||
          userGroupStatus === "Requested"
        ) {
          const pathName = constant.communityHome + groupId;
          routeService.routePage(this.props, pathName);
        }
        this.setCommunity(result);
      })
      .catch((err) => console.log(err));
  };

  setCommunity = (community) => {
    this.setState({
      community: community,
      loader: false
    });
  };

  loadUserAssignment(assignmentId) {
    const originName = window.location.origin.replace("www.", "");
    this.setState({ loader: true });
    let url =
      api.partialURL +
      "UserAssignment/GetUserAssignment?ASSIGNMENT_ID=" +
      assignmentId +
      "&USER_ID=" +
      this.props.userEmail +
      "&ENV=" +
      api.env +
      "&ORIGIN_NM=" +
      originName;
    let params = {
      ASSIGNMENT_ID: assignmentId,
      USER_ID: this.props.userEmail,
    };

    this.fetchUserAssignment(url, params);
  }

  fetchUserAssignment = (url, params) => {
    fetch(url)
      .then((res) => res.json())
      .then((result) => {
        this.setAssignment(url, params, result);
      })
      .catch((err) => console.log(err));
  };

  setAssignment = (url, params, assignment) => {
    let desc = assignment.ASSIGNMENT_DESC;
    let mediaLink = desc.slice(
      desc.indexOf('<oembed url="') + 13,
      desc.lastIndexOf('"></oembed>')
    );
    if (
      mediaLink.indexOf("https://youtube.com/") > -1 ||
      mediaLink.indexOf("https://youtu.be/") ||
      mediaLink.indexOf("https://www.youtube.com/") > -1 ||
      mediaLink.indexOf("https://www.youtu.be/")
    ) {
      let videoId = CommonFunc.getYoutubeId(mediaLink);
      let iframeMarkup =
        '<iframe frameborder="0" style="width:560px;height:315px;" src="https://www.youtube.com/embed/' +
        videoId +
        '" title="YouTube Video" allowFullScreen webkitAllowFullScreen></iframe>';
      let oembedMarkup =
        '<figure class="media"><oembed url="' +
        mediaLink +
        '"></oembed></figure>';

        assignment.ASSIGNMENT_DESC = desc.replace(oembedMarkup, iframeMarkup);
    }

    this.setState({
      userAssignment: assignment,
      loader: false,
    });
    this.props.cacheActions.setCache(url, params, assignment);
  };

  loadUploadedAssignments = (userId, assignmentId, groupId) => {
    if (this.state.community.UserGroupStatus === "Owner") {
      const inputs = assignmentId + "/" + groupId + "/" + api.env;
      const url = "UserAssignment/GetUploadedAssignments";
      fetch(api.partialURL + url + '/' + inputs).then((res) => res.json())
      .then((result) => {
        this.setState({uploadedAssignments: result.assignments});
      });
    }
    else if (this.state.community.UserGroupStatus === "Member") {
      const inputs = userId + "/" + assignmentId + "/" + groupId + "/" + api.env;
      const url = "UserAssignment/GetUploadedAssignmentsByUser";
      fetch(api.partialURL + url + '/' + inputs).then((res) => res.json())
      .then((result) => {
        this.setState({uploadedAssignments: result.assignments});
      });
    }
  };

  showFullImage = () => {
    this.setState({ viewImage: true });
  };

  handleViewImgClose = () => {
    this.setState({ viewImage: false });
  };

  handleChangeCKEditor = (e, editor) => {
    let data = editor.getData();
    this.setState({ editedDescription: data });
  };

  handleReadyCKEditor = (editor) => {
    let desc = this.state.editedDescription;
    desc = desc.replace(
      '<iframe frameborder="0" style="width:560px;height:315px;" src="',
      '<figure class="media"><oembed url="'
    );
    desc = desc.replace(
      '" title="YouTube Video" allowFullScreen webkitAllowFullScreen></iframe>',
      '"></oembed></figure>'
    );
    editor.setData(desc);
  };

  handleSaveUpdate = () => {
    if (!(this.state.editedTitle && this.state.editedDescription)) {
      alert("Title or Description cannot be empty");
      return;
    }

    this.setState({ editDialogOpen: false }); // Close the dialog after saving/updating
    const rowData = {
      assignmentId: this.props.match.params.assignmentId,
      title: this.state.editedTitle,
      description: this.state.editedDescription,
      userEnv: api.env
    };

    axios({
      method: "post",
      url: api.partialURL + "EditAssignment/UpdateUserAssignment",
      data: JSON.stringify(rowData),
      headers: { "Content-Type": "application/json" },
      mode: "cors",
    })
      .then((response) => {
        // Handle success
        // Close the dialog after saving/updating
        this.setState({ editDialogOpen: false });
        let pathName =
          constant.assignmentDetails +
          rowData.assignmentId;
        this.props.history.push(pathName);
        this.loadUserAssignment(rowData.assignmentId);
        window.location.reload();
      })
      .catch((error) => {
        // Handle error
        console.error("Error updating assignment:", error);
      });
  };

  isPdfFile = (fileName) => {
    if (fileName) {
        const parts = fileName.split('.');
        return parts.length > 1 && parts.pop().toLowerCase() === 'pdf';
    }
    else
        return false;
  };

  uploadAssignment = () => {
    this.setState({showUpload: true});
  }

  getMimeType = (fileName) => {
    const fileExtension = fileName.split(".").pop();
    if (fileExtension === "pdf")
      return "application/pdf";
    else if (fileExtension === "jpg")
      return "image/jpg";
    else if (fileExtension === "jpeg")
      return "image/jpeg";
    else if (fileExtension === "png")
      return "image/png";
    else if (fileExtension === "gif")
      return "image/gif";
  }

  downloadAssignment = (fileName, fileUrl) => {
    const mimeType = this.getMimeType(fileName);
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleModalClose = () => {
    this.setState({showUpload: false});
  }

  handleFileSave = (fileName, fileBase64String, fileUrl) => {
    const originName = window.location.origin.replace('www.', '');
    let rowData = {
      FILE_NAME: fileName,
      FILE_BASE64_STR: fileBase64String,
      FILE_URL: fileUrl,
      GROUP_ID: this.state.userAssignment.GROUP_ID,
      UPLOAD_USER_ID: this.props.userEmail,
      ORIGIN_NM: originName,
      ENV: api.env      
    };
    update("UserAssignment/UploadAssignment", rowData, this.props.match.params.assignmentId)
    .then((response) => {
      this.handleModalClose();
      this.loadUploadedAssignments(this.props.userEmail, this.state.assignmentId, this.state.groupId);
      const groupStatus = this.state.community.UserGroupStatus;
      this.loadAssignmentStatus(this.props.userEmail, this.state.assignmentId, this.state.groupId, groupStatus);
    })
    .catch(function (response) {
      this.setState({ err_msg: response, loader: false });
    });
  };

  handleAccordionChange = (panel) => (event, newExpanded) => {
    this.setState({ expanded: newExpanded ? panel : false });
  };

  handleToggleChange = (event) => {
    this.setState({checked: event.target.checked});
    let rowData = {
      assignmentId: this.state.assignmentId,
      allowSubmission: event.target.checked,
      userEnv: api.env      
    };
    axios({
      method: "post",
      url: api.partialURL + "EditAssignment/AllowAssignmentSubmission",
      data: JSON.stringify(rowData),
      headers: { "Content-Type": "application/json" },
      mode: "cors",
    })
    .then((response) => {})
    .catch((error) => {
      console.error("Error in enabling or disabling assignment submission:", error);
    });
  };

  loadAllowAssignmentSubmission = (assignmentId) => {
    this.setState({ loader: true });
    let url =
      api.partialURL +
      "UserAssignment/GetAllowAssignmentSubmission?ASSIGNMENT_ID=" +
      assignmentId +
      "&ENV=" +
      api.env; 
    fetch(url)
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          checked: result.allowSubmission? true: false,
          loader: false,
        });
      })
      .catch((err) => console.log(err));
  };

  render() {
    const { classes, mediaQuery } = this.props;
    const col3 = mediaQuery ? 3 : 12;
    const col7 = mediaQuery ? 7 : 12;
    const col2 = mediaQuery ? 2 : 12;
    const subHeader = classNames(classes.posTop, classes.subHeader);
    const subHeaderX = classNames(classes.posTopX, classes.subHeader);
    
    return (
      <Fragment>
        <Backdrop className={classes.backdrop} open={this.state.loader}>
          <img src={EDWhatLogoIcon} height={50} alt="Logo" />
        </Backdrop>

        <UploadFile
            show={this.state.showUpload}
            handleModalClose={this.handleModalClose}
            handleFileSave={this.handleFileSave}
            >
        </UploadFile>

        {this.state.viewImage && (
          <ViewImage
            open={this.state.viewImage}
            preViewImage={this.state.userAssignment.ASSIGNMENT_IMG_URL}
            handleViewImgClose={this.handleViewImgClose}
          />
        )}

        {this.state.userAssignment.ASSIGNMENT_ID && (
          <Grid
            container
            spacing={4}
            style={{ marginTop: mediaQuery ? "45px" : "90px" }}
            className={mediaQuery ? classes.contentHome : null}
          >
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} key={this.state.userAssignment.ASSIGNMENT_ID}>
                  <Card>
                    <CardHeader
                      classes={{
                        title: classes.title,
                        subheader: classes.subTitle,
                      }}
                      title={this.state.userAssignment.ASSIGNMENT_TITLE}
                      subheader={
                        "posted by " +
                        this.state.userAssignment.ASSIGNMENT_UPDT_USER_NM +
                        " " +
                        this.state.userAssignment.ASSIGNMENT_UPDT_DTM +
                        " ago"
                      }
                      style={{ padding: "16px 16px 0px 16px" }}
                      action={
                        (
                          (this.props.userEmail === this.state.userAssignment.ASSIGNMENT_UPDT_USER_ID) && 
                          (this.state.community.UserGroupStatus === "Owner") && (
                            <div>
                              <Tooltip title={this.state.checked ? "Submissions allowed" : "Submissions disabled"}>
                                <Switch
                                  checked={this.state.checked}
                                  onChange={this.handleToggleChange}
                                  slotProps={{ input: { 'aria-label': 'controlled' } }}
                                  style={{color: "#C2272D"}}
                                />
                              </Tooltip>
                              <IconButton
                                onClick={() => {
                                  // Open the edit dialog
                                  this.setState({
                                    editDialogOpen: true,
                                    // Pass the current title and description to the state
                                    editedTitle: this.state.userAssignment.ASSIGNMENT_TITLE,
                                    editedDescription:
                                      this.state.userAssignment.ASSIGNMENT_DESC,
                                  });
                                }}
                              >
                                <EditIcon />
                              </IconButton>
                            </div>
                          )
                        ) || (
                          (this.state.community.UserGroupStatus === "Member") && (this.state.userAssignment.ALLOW_SUBMISSION == 1) && (
                            <Button
                              variant="contained"
                              className={classes.customButtonError}
                              size="small"
                              onClick={this.uploadAssignment}
                              style={{ float: "right", margin: "10px" }}
                            >
                              Upload Assignment
                            </Button>
                          )
                        ) || (
                          (this.state.community.UserGroupStatus === "Member") && (this.state.userAssignment.ALLOW_SUBMISSION == 0) && (
                            <Typography style={{color: "#C2272D"}}>
                              Submission is closed
                            </Typography>
                          )
                        )
                      }
                    />

                    <CardContent>
                      <Typography
                        className={
                          this.state.userAssignment.ASSIGNMENT_DESC.substring(0, 23) ===
                          '<iframe frameborder="0"'
                            ? subHeaderX
                            : subHeader
                        }
                        gutterBottom
                      >
                        <div>
                          {mediaQuery
                            ? ReactHtmlParser(this.state.userAssignment.ASSIGNMENT_DESC)
                            : ReactHtmlParser(
                                this.state.userAssignment.ASSIGNMENT_DESC.replace(
                                  'style="width:560px;height:315px;"',
                                  ""
                                )
                              )}
                        </div>
                      </Typography>
                      {this.state.userAssignment.ASSIGNMENT_IMG_URL && !this.isPdfFile(this.state.userAssignment.ASSIGNMENT_IMG_URL) && (
                        <Typography>
                          <img
                            src={this.state.userAssignment.ASSIGNMENT_IMG_URL}
                            onClick={this.showFullImage}
                            alt="img"
                            style={{
                              width: "100%",
                              padding: mediaQuery
                                ? "10px 150px 10px 150px"
                                : "10px 10px 10px 10px",
                            }}
                          />
                        </Typography>
                      )}
                       {this.state.userAssignment.ASSIGNMENT_IMG_URL && this.isPdfFile(this.state.userAssignment.ASSIGNMENT_IMG_URL) && (
                        <Typography>
                          <Link href={this.state.userAssignment.ASSIGNMENT_IMG_URL} target="_blank">
                            <PictureAsPdfIcon/>
                            {this.state.userAssignment.ASSIGNMENT_IMG_URL.split("/")[this.state.userAssignment.ASSIGNMENT_IMG_URL.split("/").length - 1]}
                          </Link>
                        </Typography>
                      )
                      }                      
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        {(this.state.community.UserGroupStatus === "Owner") && (
          <div>
            <Divider orientation="horizontal" style={{ marginTop: 20, marginBottom: 20 }} />      
            {mediaQuery ? (
              <Grid container spacing={4} className={mediaQuery ? classes.contentHome : null}>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Card>
                        <CardHeader
                          classes={{
                            title: classes.title,
                            subheader: classes.subTitle,
                          }}
                          title={"User Assignment Upload Status"}
                          subheader={""}
                          style={{ padding: "16px 16px 0px 16px" }}
                        />
                        <CardContent>
                          <Typography
                            className={subHeader}
                            gutterBottom
                          >
                            It shows assignment status list of all users of the community
                          </Typography>
                          <Table aria-label="caption table" size="small">
                            <TableHead style={{ backgroundColor: "#c2272d" }}>
                              <TableRow>
                                <TableCell className={classes.tableHeadCell} align="center">
                                  User Name
                                </TableCell>
                                <TableCell className={classes.tableHeadCell} align="center">
                                  Status
                                </TableCell>
                                <TableCell className={classes.tableHeadCell} align="center">
                                  Date Uploaded
                                </TableCell>
                                <TableCell className={classes.tableHeadCell} align="center">
                                  File Uploaded
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.userAssignmentStatus.map((row, index) => (
                                <TableRow key={row.UPLOAD_DTM}>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    align="center"
                                  >
                                    {row.UPLOAD_USER_NAME}
                                    <div className={classes.caption}>{row.UPLOAD_USER_EMAIL}</div>
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    align="center"
                                  >
                                    {row.FILE_NAME ? "Submitted" : "Not Submitted"}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    align="center"
                                  >
                                    {row.UPLOAD_DTM ? row.UPLOAD_DTM : "-"}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    align="center"
                                  >
                                    {row.FILE_NAME ? (
                                      <Button
                                      variant="contained"
                                      className={classes.customButtonError}
                                      size="small"
                                      onClick={() => this.downloadAssignment(row.FILE_NAME, row.FILE_URL)}
                                    >
                                      Download
                                    </Button>
                                    ): "-"}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <div>
                <Grid container spacing={4} className={mediaQuery ? classes.contentHome : null}>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Card>
                          <CardHeader
                            classes={{
                              title: classes.title,
                              subheader: classes.subTitle,
                            }}
                            title={"User Assignment Upload Status"}
                            subheader={""}
                            style={{ padding: "16px 16px 0px 16px" }}
                          />
                          <CardContent>
                            <Typography
                              className={subHeader}
                              gutterBottom
                            >
                              It shows assignment status list of all users of the community
                            </Typography>
                            {this.state.userAssignmentStatus.map((row, index) => (
                              <MuiAccordion
                                expanded={this.state.expanded === row.UPLOAD_USER_ID}
                                onChange={this.handleAccordionChange(row.UPLOAD_USER_ID)}
                                style={{ width: "100%" }}
                              >
                                <MuiAccordionSummary
                                  aria-controls="panel1d-content"
                                  id="panel1d-header"
                                >
                                  <Grid container spacing={0}>
                                    <Grid item xs={11}>
                                      <Typography className={classes.accordionSubText}>
                                        {row.UPLOAD_USER_NAME}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </MuiAccordionSummary>
                                <MuiAccordionDetails>
                                  <Typography>
                                    <div>
                                      <span className={classes.accordionSubTitle}>
                                        User Name :{" "}
                                      </span>
                                      <span className={classes.accordionSubText}>
                                        {row.UPLOAD_USER_NAME}
                                      </span>
                                    </div>
                                    <Divider className={classes.dividerMargin} />
                                    <div>
                                      <span className={classes.accordionSubTitle}>
                                        User Email :{" "}
                                      </span>
                                      <span className={classes.accordionSubText}>
                                        {row.UPLOAD_USER_EMAIL}
                                      </span>
                                    </div>
                                    <Divider className={classes.dividerMargin} />
                                    <div>
                                      <span className={classes.accordionSubTitle}>
                                        Status :{" "}
                                      </span>
                                      <span className={classes.accordionSubText}>
                                        {row.FILE_NAME ? "Submitted" : "Not Submitted"}
                                      </span>
                                    </div>
                                    <Divider className={classes.dividerMargin} />
                                    <div>
                                      <span className={classes.accordionSubTitle}>
                                        Date Uploaded :{" "}
                                      </span>
                                      <span className={classes.accordionSubText}>
                                        {row.UPLOAD_DTM ? row.UPLOAD_DTM : "-"}
                                      </span>
                                    </div>
                                    <Divider className={classes.dividerMargin} />
                                    <div>
                                      <span className={classes.accordionSubTitle}>
                                        File Uploaded :{" "}
                                      </span>
                                      <span className={classes.accordionSubText}>
                                        {row.FILE_NAME ? (
                                          <Button
                                          variant="contained"
                                          className={classes.customButtonError}
                                          size="small"
                                          onClick={() => this.downloadAssignment(row.FILE_NAME, row.FILE_URL)}
                                          >
                                            Download
                                          </Button>
                                        ): "-"}
                                      </span>
                                    </div>
                                  </Typography>
                                </MuiAccordionDetails>
                              </MuiAccordion>
                            ))}
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            )}
          </div>
        )}

        {(this.state.community.UserGroupStatus === "Member") && (
          <div>
            <Divider orientation="horizontal" style={{ marginTop: 20, marginBottom: 20 }} />      
            {mediaQuery ? (
              <Grid container spacing={4} className={mediaQuery ? classes.contentHome : null}>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Card>
                        <CardHeader
                          classes={{
                            title: classes.title,
                            subheader: classes.subTitle,
                          }}
                          title={"Submitted Assignments"}
                          subheader={""}
                          style={{ padding: "16px 16px 0px 16px" }}
                        />
                        <CardContent>
                          <Typography
                            className={subHeader}
                            gutterBottom
                          >
                            Kindly click the “Upload Assignment” button to proceed with your submission. Multiple submissions are allowed.
                          </Typography>
                          <Table aria-label="caption table" size="small">
                            <TableHead style={{ backgroundColor: "#c2272d" }}>
                              <TableRow>
                                <TableCell className={classes.tableHeadCell} align="center">
                                  Status
                                </TableCell>
                                <TableCell className={classes.tableHeadCell} align="center">
                                  Date Uploaded
                                </TableCell>
                                <TableCell className={classes.tableHeadCell} align="center">
                                  File Uploaded
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.userAssignmentStatus.map((row, index) => (
                                <TableRow key={row.UPLOAD_DTM}>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    align="center"
                                  >
                                    {row.FILE_NAME ? "Submitted" : "Not Submitted"}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    align="center"
                                  >
                                    {row.UPLOAD_DTM ? row.UPLOAD_DTM : "-"}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableBodyCell}
                                    align="center"
                                  >
                                    {row.FILE_NAME ? (
                                      <Button
                                      variant="contained"
                                      className={classes.customButtonError}
                                      size="small"
                                      onClick={() => this.downloadAssignment(row.FILE_NAME, row.FILE_URL)}
                                    >
                                      Download
                                    </Button>
                                    ): "-"}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <div>
                <Grid container spacing={4} className={mediaQuery ? classes.contentHome : null}>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Card>
                          <CardHeader
                            classes={{
                              title: classes.title,
                              subheader: classes.subTitle,
                            }}
                            title={"Submitted Assignments"}
                            subheader={""}
                            style={{ padding: "16px 16px 0px 16px" }}
                          />
                          <CardContent>
                            <Typography
                              className={subHeader}
                              gutterBottom
                            >
                              Kindly click the “Upload Assignment” button to proceed with your submission. Multiple submissions are allowed.
                            </Typography>
                            {this.state.userAssignmentStatus.map((row, index) => (
                              (row.UPLOAD_DTM !== null)? (
                                <MuiAccordion
                                  expanded={this.state.expanded === row.UPLOAD_DTM}
                                  onChange={this.handleAccordionChange(row.UPLOAD_DTM)}
                                  style={{ width: "100%" }}
                                >
                                  <MuiAccordionSummary
                                    aria-controls="panel1d-content"
                                    id="panel1d-header"
                                  >
                                    <Grid container spacing={0}>
                                      <Grid item xs={11}>
                                        <Typography className={classes.accordionSubText}>
                                          {row.UPLOAD_DTM}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </MuiAccordionSummary>
                                  <MuiAccordionDetails>
                                    <Typography>
                                      <div>
                                        <span className={classes.accordionSubTitle}>
                                          Status :{" "}
                                        </span>
                                        <span className={classes.accordionSubText}>
                                          {row.FILE_NAME ? "Submitted" : "Not Submitted"}
                                        </span>
                                      </div>
                                      <Divider className={classes.dividerMargin} />
                                      <div>
                                        <span className={classes.accordionSubTitle}>
                                          Date Uploaded :{" "}
                                        </span>
                                        <span className={classes.accordionSubText}>
                                          {row.UPLOAD_DTM ? row.UPLOAD_DTM : "-"}
                                        </span>
                                      </div>
                                      <Divider className={classes.dividerMargin} />
                                      <div>
                                        <span className={classes.accordionSubTitle}>
                                          File Uploaded :{" "}
                                        </span>
                                        <span className={classes.accordionSubText}>
                                          {row.FILE_NAME ? (
                                            <Button
                                            variant="contained"
                                            className={classes.customButtonError}
                                            size="small"
                                            onClick={() => this.downloadAssignment(row.FILE_NAME, row.FILE_URL)}
                                          >
                                            Download
                                          </Button>
                                          ): "-"}
                                        </span>
                                      </div>
                                    </Typography>
                                  </MuiAccordionDetails>
                                </MuiAccordion>
                              ) : null
                            ))}
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            )}
          </div>
        )}

        <Dialog
          open={this.state.editDialogOpen}
          onClose={this.handleEditDialogClose}
          maxWidth="md"
        >
          <DialogTitle>Edit Assignment</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              name="assignment_title"
              label="Title"
              required
              onChange={(event) =>
                this.setState({ editedTitle: event.target.value })
              }
              noValidate
              value={this.state.editedTitle}
              size="small"
              variant="outlined"
              style={{ backgroundColor: "#e7e7e7", marginBottom: 20 }}
            />

            <CKEditor
              size="small"
              editor={ClassicEditor}
              data={this.state.editedDescription}
              onChange={this.handleChangeCKEditor}
              onReady={this.handleReadyCKEditor}
              config={{
                toolbar: [
                  "heading",
                  "|",
                  "bold",
                  "italic",
                  "underline",
                  "bulletedList",
                  "numberedList",
                  "blockQuote",
                  "link",
                  "mediaEmbed",
                  "|",
                  "undo",
                  "redo",
                ],
                placeholder: "Type assignment description here *",
              }}
              style={{ marginTop: 20 }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ editDialogOpen: false })}
              color="primary"
            >
              Cancel
            </Button>
            <Button onClick={this.handleSaveUpdate} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

export default withRouter(
  withStyles(useStyles)(withMediaQuery("(min-width:600px)")(AssignmentDetails))
);
